import { Link } from "react-router-dom";
import { useTranslation } from "../lib/i18n";

const FOOTER_SECTIONS = [
  {
    title: "Platform",
    links: [
      { labelKey: "nav.architecture", to: "/architecture" },
      { labelKey: "nav.domains", to: "/domains" },
      { labelKey: "nav.industries", to: "/industries" },
      { labelKey: "nav.analytics", to: "/analytics" },
    ],
  },
  {
    title: "Programs",
    links: [
      { labelKey: "nav.licensing", to: "/licensing" },
      { labelKey: "nav.pricing", to: "/pricing" },
      { labelKey: "nav.training", to: "/training" },
      { labelKey: "nav.certification", to: "/certification" },
    ],
  },
  {
    title: "Resources",
    links: [
      { labelKey: "nav.downloads", to: "/downloads" },
      { labelKey: "nav.community", to: "/community" },
      { labelKey: "nav.contact", to: "/contact" },
      { labelKey: "nav.register", to: "/register" },
    ],
  },
];

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      style={{
        background: "var(--bg-dark)",
        color: "var(--text-on-dark)",
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="container" style={{ padding: "var(--space-10) var(--space-4)" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2fr repeat(3, 1fr)",
            gap: "var(--space-6)",
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "0.625rem", marginBottom: "1rem" }}>
              <img
                src="/sentinel-white.png"
                alt="Sentinel logo"
                style={{ width: "32px", height: "32px", objectFit: "contain" }}
              />
              <span style={{ fontWeight: 800, fontSize: "1.125rem" }}>Sentinel</span>
            </div>
            <p style={{ color: "var(--text-muted-on-dark)", fontSize: "0.875rem", maxWidth: "320px" }}>
              Intelligent Multi-Domain Safety & Autonomous Intervention. Monitoring, diagnosing, and responding across physical, digital, and operational domains in real time.
            </p>
          </div>
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title}>
              <h4
                style={{
                  fontSize: "0.8125rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--neutral-300)",
                  marginBottom: "1rem",
                }}
              >
                {section.title}
              </h4>
              <ul style={{ display: "flex", flexDirection: "column", gap: "0.625rem" }}>
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      style={{
                        color: "var(--text-muted-on-dark)",
                        fontSize: "0.875rem",
                        transition: "color var(--transition-fast)",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent-400)")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted-on-dark)")}
                    >
                      {t(link.labelKey)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div
          style={{
            marginTop: "var(--space-8)",
            paddingTop: "var(--space-4)",
            borderTop: "1px solid rgba(255,255,255,0.06)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <p style={{ color: "var(--text-muted-on-dark)", fontSize: "0.8125rem" }}>
            &copy; {new Date().getFullYear()} E Industries. {t("footer.rights")}
          </p>
          <p style={{ color: "var(--text-muted-on-dark)", fontSize: "0.8125rem" }}>
            {t("footer.poweredBy")}
          </p>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          footer .container > div:first-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}
